import { coSoApi } from '../../../api/category/coSoApi';

import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { rootActions } from '../../actions/rootActions';
import { eCoSoActionTypeIds, ICoSoActions } from './../../action-types/category/ICoSoActionType';
const mainAction = rootActions.category.coSo;
export function* coSoSaga(): any {
    yield takeLatest(eCoSoActionTypeIds.LOAD_START, loadWorker)
}

function* loadWorker(action: ICoSoActions): any {
    const res: IBaseRespone = yield call(coSoApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}
